module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/PayrollItem.ejs -->\n<td class="td-nowrap">\n    <input type="hidden" name="eaFields" disabled>\n\n    <div class="form-control form-control-with-delete">\n        <span class="form-control-value"></span>\n\n        <input name="name"\n            class="form-control form-control-invisible"\n            type="text" autocomplete="off"\n            value="'+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'">\n\n        <a class="form-control-delete fa fa-times btn-delete js-destroy"\n            tabindex="-1"></a>\n    </div>\n    ';
 if (showType) { 
__p+='\n        <div class="m-l-sm">(type: '+
((__t=( model.get('type') ))==null?'':_.escape(__t))+
')</div>\n    ';
 } 
__p+='\n\n    <div class="error error-name error-isUnit error-isGross error-isNet\n        error-allowRecurrency error-affectsMtd error-affectsEpf\n        error-eaFields error-affectsSocso error-affectsEis">\n    </div>\n    <div class="error error-name error-isUnit error-isGross error-isNet\n        error-allowRecurrency error-affectsMtd error-affectsEpf\n        error-affectsSocso error-eaFields error-affectsEis error-placeholder">\n    </div>\n</td>\n\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="isUnit"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('isUnit') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="isGross"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('isGross') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="isNet"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('isNet') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsMtd"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('affectsMtd') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsEpf"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('affectsEpf') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsSocso"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('affectsSocso') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <label class="ichecks">\n        <input type="checkbox" value="1" name="affectsEis"\n            data-value-type="boolean" class="js-icheck"\n            '+
((__t=( model.get('affectsEis') ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n        <i></i>\n    </label>\n</td>\n<td class="form-group">\n    <input type="text" name="mtdLimit"\n    class="form-control form-control-invisible"\n        value="'+
((__t=( model.getMtdLimit().toFixed(2) ))==null?'':_.escape(__t))+
'"\n        data-value-type="float"\n        '+
((__t=( !model.get('affectsMtd') ? 'disabled' : '' ))==null?'':_.escape(__t))+
'>\n</td>\n<td>\n    <select name="taxExemptEaField"\n        class="form-control js-ext js-ext-eaField js-attr-eaFields">\n        <option disabled '+
((__t=( !model.getTaxExemptEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n            value="">\n            Select an option\n        </option>\n        <option value="none">None</option>\n        ';
 Object.keys(eaFields).forEach(function(field) { 
__p+='\n            <option value="'+
((__t=( field ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( model.getTaxExemptEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( eaFields[field] ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n<td>\n    <select name="eaField" class="form-control js-ext js-ext-eaField js-attr-eaFields">\n        <option disabled '+
((__t=( !model.getEaField() ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n            value="">\n            Select an option\n        </option>\n        <option value="none">None</option>\n        ';
 Object.keys(eaFields).forEach(function(field) { 
__p+='\n            <option value="'+
((__t=( field ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( model.getEaField() === field ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( eaFields[field] ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n';
 /*
<td>
    <a href="" title="Edit" class="js-edit">
        <i class="fa fa-pencil fa-2x"></i>
    </a>
</td> */ 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/PayrollItem.ejs
// module id = 697
// module chunks = 1